export const routeSegments = {
  en: {
    about: 'about',
    services: 'services',
    caseStudies: 'case-studies',
    contact: 'contact',
  },
  hu: {
    about: 'rolunk',
    services: 'szolgaltatasok',
    caseStudies: 'esettanulmanyok',
    contact: 'kapcsolat',
  },
} as const;

export type Language = keyof typeof routeSegments;
export type SegmentKey = keyof typeof routeSegments.en;

export type RouteKey = 'home' | 'about' | 'services' | 'serviceDetail' | 'caseStudies' | 'contact';

export interface RouteParams {
  slug?: string;
  query?: Record<string, string>;
}

// Reverse lookup: segment string → { lang, key }
export const reverseSegmentMap: Record<string, { lang: Language; key: SegmentKey }> = {};

for (const lang of Object.keys(routeSegments) as Language[]) {
  for (const key of Object.keys(routeSegments[lang]) as SegmentKey[]) {
    reverseSegmentMap[routeSegments[lang][key]] = { lang, key };
  }
}
